import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
// slices
import riceInspectResult from "./slices/riceInspectResult";
import roleReducer from "./slices/role";

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const rootReducer = combineReducers({
  riceInspectResult: riceInspectResult,
  account: combineReducers({
    role: roleReducer,
  }),
});

export default rootReducer;
